import { SafeResourceUrl } from '@angular/platform-browser';

export interface CodeType {
  type: string;
  display: string;
}

export interface PanelType {
  icon: string;
  display: string;
  type: string;
}

export interface TikZType {
  id: string;
  data: string;
}

export interface MultiData {
  type: string;
  data: string;
  hidden?: boolean;
  images: string[];
  selectedVideos?: any[];
  isUploading?: boolean;
  uploadProgress?: number;
  videos?: Video[];
}

export interface Video {
  videoId: number;
  isActive: boolean;
  isEditorActive?: boolean;
}

export interface MultiDataInput {
  type: string;
  data: string;
  tikzId: string;
  listOfImages: any;
  imageKeys: string[];
  videos?: Video[];
  videoMap?: Map<number, any>;
}

// ** removed 'ignoredQuestionCategories' property (temp solution)
export interface GetQUestionParams {
  topicId: number;
  subTopicId: number;
  difficultyLevel: number | null;
  pageNo: number;
  questionType: number | null;
  tags: string;
  canRepeatQuestions?: boolean;
  ignoredQuestionCategories?: string;
}

export interface GetQUestionParamsInQuestionBank {
  topicId: number;
  subTopicId: number;
  difficultyLevel: number | null;
  pageNo: number;
  questionType: number | null;
  tags: string;
  questionCategories?: number;
}

export const options: string[] = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J'
];

export const codeTypes: CodeType[] = [
  {
    type: 'MathJax',
    display: 'MathJax'
  },
  // {
  //   type: 'TikZ',
  //   display: 'TikZ',
  // },
  // {
  //   type: 'Katex',
  //   display: 'Katex',
  // },
  {
    type: 'URL',
    display: 'Url'
  },
  {
    type: 'Images',
    display: 'Images'
  },
  {
    type: 'Videos',
    display: 'Videos'
  },
  {
    type: 'Empty',
    display: 'Empty'
  }
];

export const panelTypes: PanelType[] = [
  {
    icon: 'assignment',
    display: 'Overview',
    type: 'overview'
  },
  {
    icon: 'wb_sunny',
    display: 'Tip',
    type: 'tip'
  },
  {
    icon: 'extension',
    display: 'Exercise (From Question Bank)',
    type: 'qb'
  },
  {
    icon: 'extension',
    display: 'Exercise (Enter Manually)',
    type: 'manual'
  },
  {
    icon: 'wb_sunny',
    display: 'Example',
    type: 'example'
  },
  {
    icon: 'assignment_late',
    display: 'General',
    type: 'general'
  },
  {
    icon: 'assignment_late',
    display: 'Key takeaways',
    type: 'kta'
  },
  {
    icon: 'quiz',
    display: 'Quiz',
    type: 'quiz'
  }
];

// new dashboard
export interface dueItem {
  assignmentType: string;
  dueByDate: string | Date;
  assignedDate: string | Date;
  isAssignment: boolean;
  status: string | number;
  name: string;
  category: string | number;
}

export interface userInfo {
  name: string;
  courses: string[];
  ppic: string;
}

export interface nextClass {
  courseName: string;
  tutorName: string;
  classTime: string | Date | number;
  classType: string | number;
  upcomingDate: string | Date;
  isAvailable: boolean;
}

export interface practiceStat {
  activity: string;
  due: number;
  ongoing: number;
  done: number;
}

export interface testCreationSection {
  sectionName: string;
  sectionType: string | number;
  totalDuration: string | number;
  breakDuration: string | number;
  breakAfterModule: boolean;
  canBePaused: boolean;
  // generatedQuestions?: generatedQuestionObj[];
  generatedQuestions: subTopicQuestionDetailNew[];
  moduleId: number;
  moduleOrder: number;
  id: string;
  isExistingSection?: boolean;
  subTopicQuestionDetails: subTopicQuestionDetail[];
  generateQuestionsStructPerModule?: generateQuestionStruct[];
  canRepeatQuestions: boolean;
  ignoredQuestionCategories: string[];
  // onlyTestQuestions: boolean;
  onlyExerciseQuestions: boolean;
  onlyQuizQuestions: boolean;
  isValid: boolean;
  isBreakDurationValid: boolean;
  isTotalDurationValid: boolean;
  questionTypeCount: moduleWiseQuestionsTypeCount;
}

export interface QuestionIdInfo {
  scoringSectionName: number | string;
  moduleName: string;
  questionIdIndex: number;
  questionId: number;
}

// export interface RepeatedQuestionsStruct {

//   moduleName: string;
//   questionIdsInfo: QuestionIdInfo[];
// }

export interface PrintTestSection {
  sectionType: string | number;
  sectionName: string;
  questions: subTopicQuestionDetailNew[];
  isPrintAllowed: boolean;
}

export interface questionCreated {
  question: string;
  options: string[];
  answers: number[] | string[];
  tags: string[];
  subTopicName: string;
  difficulty: string | number;
  questionType: string | number;
}

export interface genMatOption {
  value: string | number;
  displayValue: string;
}

export interface course {
  courseId: number;
  courseName: string;
}

export interface coursesRes {
  msg: string;
  data: course[];
}

export interface testType {
  testTypeId: number;
  testTypeName: string;
  courceId?: number;
}

export interface StudentProgressBatch {
  batchId: number;
  batchName: string;
}

export interface StudentProgressBatchesRes {
  msg: string;
  data: StudentProgressBatch[];
}

export interface StudentProgressQuestionStats {
  totalQuestions: number;
  attempted: number;
  correct: number;
}

// A test's own scoring sections (Math, English, ...). Note this sectionId is a
// scoring-section id, a different id space from StudentProgressSection.sectionId
// (a tst_id used for the table's columns) — never cross-reference the two.
export interface StudentProgressTestSectionStats extends StudentProgressQuestionStats {
  sectionId: number;
  sectionName: string | null;
  // Achieved score for this section, null until the section is scored.
  score?: number | null;
  scoreMin?: number | null;
  scoreMax?: number | null;
}

export interface StudentProgressStatusItem {
  id?: string | null;
  name?: string | null;
  status: string;
  date?: string | null;
  // What `date` means for this item: 'assigned_date' (learning modules),
  // 'created_on' (workshops), or 'complete_by' (tests).
  dateType?: string;
  completedDate?: string | null;
  // Learning modules and workshops only; null on tests.
  quiz?: StudentProgressQuestionStats | null;
  exercise?: StudentProgressQuestionStats | null;
  // Tests only; null on learning modules and workshops.
  sections?: StudentProgressTestSectionStats[] | null;
}

export interface StudentProgressSection {
  sectionId: number;
  sectionName: string;
}

export interface StudentProgressSectionGroup extends StudentProgressSection {
  items: StudentProgressStatusItem[];
}

export interface StudentProgressStudentRow {
  studentId: number;
  firstName: string;
  lastName: string;
  tests: StudentProgressStatusItem[];
  learningModules: StudentProgressSectionGroup[];
  workshops: StudentProgressSectionGroup[];
}

export interface StudentProgressSearchRequest {
  courseId: number;
  viewBy: 'student' | 'batch';
  batchIds: number[];
  batchStatus: 0 | 1;
  recordsPerSection: number;
  studentName: string;
}

export interface StudentProgressSearchData {
  courseId: number;
  courseName: string;
  recordsPerSection: number;
  sections: StudentProgressSection[];
  students: StudentProgressStudentRow[];
}

export interface StudentProgressSearchResponse {
  msg: string;
  data: StudentProgressSearchData;
}

export interface scoringSection {
  test_section: string;
  scoring_section_name: string;
  test_section_id: number;
  test_section_type_id: number;
  tst_id: number;
  scoring_section_type_id: number;
}

export interface scoringSectionResBeforeParse {
  msg: string;
  data: string;
}

export interface scoringSectionResAfterParse {
  msg: string;
  data: scoringSection[];
}

export interface subTopicByScoringAndTestId {
  subTopicId: number;
  subTopicName: string;
}

export interface subTopiclistByModule {
  moduleId: number;
  subTopicList: subTopicListByScoringId[];
}

export interface subTopicListByScoringId {
  scoringSectionId: number;
  subTopicListByScoring: subTopicByScoringAndTestId[];
}

export interface moduleSubTopic {
  moduleName: string;
  moduleSubTopics: subTopicByScoringAndTestId[];
  existingQuestionDistributionPatterns?: subTopicQuestionDetail[];
  moduleId: number;
  canRepeatQuestions: boolean;
  onlyQuizQuestions: boolean;
  questionsCount?: moduleWiseQuestionsTypeCount;
  onlyExerciseQuestions: boolean;
}

export interface readOnlyQuestionsData {
  questionType: string;
  numberOfQuestions: number;
}

export interface questionDistributionPatternTableHeaders {
  title: string;
  subTitles: string[];
}

export interface questionDistributionStruct {
  easy: number;
  medium: number;
  hard: number;
  total: number;
}

export interface questionDistributionSubTopicInfo {
  subTopicId: number;
  subTopicName: string;
  totalMcqFreetext: number;
  mcqs: questionDistributionStruct;
  freetext: questionDistributionStruct;
}

export interface questionDistributionPatternContent {
  moduleName: string;
  moduleId: number;
  subTopicInfo: questionDistributionSubTopicInfo[];
  totalQuestions: number;
  totalMcqQuestions: number;
  totalFreetextQuestions: number;
  canRepeatQuestions: boolean;
  onlyQuizQuestions: boolean;
  onlyExerciseQuestions: boolean;
}

export interface questionSpecification {
  difficultLevel: number;
  noOfQuestions: number;
  presentQuestions?: number;
  deletedQuestions?: number;
  questionType: number;
  questions?: subTopicQuestionDetailNew[];
}

// ** New Questions Holder structure (Per Sub topic)
export interface subTopicQuestionDetailNew {
  questionDetails: generatedQuestionObj;
  subTopicId: number;
  subTopicName?: string;
  questionType: number;
  difficultLevel: number;
}

export interface subTopicQuestionDetail {
  questionSpecifications: questionSpecification[];
  subTopicId: number;
}

export interface generateQuestionStruct {
  moduleName: string;
  moduleId: number;
  subTopicQuestionDetails: subTopicQuestionDetail[];
  generatedQuestions?: subTopicQuestionDetailNew[];
  questions?: generatedQuestionObj[];
  canRepeatQuestions: boolean;
  ignoredQuestionCategories: string[];
  // onlyTestQuestions: boolean;
  onlyQuizQuestions: boolean;
  onlyExerciseQuestions: boolean;
  moduleOrder?: number;
}

// ** New Module response structure (Question generation)
export interface generateQuestionStructNew {
  moduleName: string;
  moduleId?: number;
  subTopicQuestionDetails: subTopicQuestionDetailNew[];
  // questions?: generatedQuestionObj[];
  canRepeatQuestions: boolean;
}

export interface quesDistributionPattern {
  isValidQuestionnaire: boolean;
  questionStructList: generateQuestionStruct[];
}

export interface moduleValidity {
  isValidQuesstionaire: boolean;
  moduleName: string;
  moduleId: number;
}

export interface generatedQuestionOrOptionData {
  data: string;
  type: string;
  images?: string[];
}

export interface generatedQuestionTestType {
  topicId: number;
  subTopicId: number;
  testTypeId: number;
  testSectionId: number;
  difficultyLevel: number;
  isTestQuestion: boolean;
}

export interface generatedQuestion {
  questionId: number;
  questionData: generatedQuestionOrOptionData[];
  tags: string[];
  questionType: number;
  displayStyle: number;
  status: number;
}

export interface generatedOption {
  isAnswer?: boolean;
  explanation?: generatedQuestionOrOptionData[];
  optionValue: generatedQuestionOrOptionData[];
  option_id: number;
}

export interface generatedAnswer {
  explanation: generatedQuestionOrOptionData[];
  posibilities: string[];
}

export interface generatedQuestionObj {
  choices?: generatedOption[];
  answers?: generatedAnswer;
  question: generatedQuestion;
  questionTestTypes: generatedQuestionTestType[];
  moduleQuestionId?: string;
}

export interface displayGeneratedModule {
  moduleName: string;
  generatedQuestions: generatedQuestionObj[];
  moduleId: number;
  canRepeatQuestions: boolean;
  moduleOrder: number;
}

export interface deleteQuestionOrSectionConfirmation {
  isQuestion: boolean;
  subTopicIds?: number[];
  moduleIndex: number;
  questionIndex?: number;
  questionInfo?: subTopicQuestionDetailNew;
}

export interface manualReplaceQuestion {
  questionIds?: number[];
  moduleIndex: number;
  questionIndex: number;
  questionInfo: subTopicQuestionDetailNew;
  canRepeatQuestions: boolean;
  ignoredQuestionCategories: string[];
}

export interface searchQuestionRes {
  questions: generatedQuestionObj[];
}

export interface moduleWiseQuestionsTypeCount {
  totalQuestions: number;
  totalFreetext: number;
  totalMcqs: number;
  generatedQuestions: number;
  deletedQuestions: number;
}

export interface questionInfo {
  subTopicId: number;
  difficultyLevel: number;
  questionId: number;
  moduleQuestionId?: string;
  questionOrder: number;
}

export interface saveTestModule {
  breakAfterModule: boolean;
  breakDuration: number;
  canPauseModule: boolean;
  id: string;
  moduleDuration: number;
  moduleName: string;
  moduleOrder: number;
  questionsInfo: questionInfo[];
  recievedQuestions?: generatedQuestionObj[];
  scoringSectionId: number;
  subTopicQuestionDetails: subTopicQuestionDetail[];
  totalFreeText: number;
  totalMCQ: number;
  canRepeatQuestions: boolean;
  ignoredQuestionCategories: string[];
  // onlyUseTestQuestions: boolean;
  onlyExerciseQuestions: boolean;
  onlyQuizQuestions: boolean;
}

export interface saveTestStruct {
  testModuleDetails: saveTestModule[];
  testCode: string;
  testName: string;
  testNotes: string;
  testTypeId: number;
}

export interface autoReplaceStruct {
  difficultLevel: number;
  existingQuestionIds: number[];
  questionType: number;
  subTopicId: number;
  canRepeatQuestions: boolean;
  ignoredQuestionCategories: string[];
}

export interface StudentAccess {
  academic: boolean;
  testPrep: boolean;
  package: boolean;
}

export interface childInfo {
  zipcode: string;
  country: string;
  skype: string;
  haveAcademicCoaching: boolean;
  address: string;
  gender: number;
  mobile: string;
  last_name: string;
  student_id: number;
  first_name: string;
  haveTestPrep: boolean;
  email: string;
}

export interface PaymentTypes {
  createdOn: string;
  paymentTypeId: number;
  paymentTypeName: string;
  updatedOn: string;
}

export interface InvoiceInfo {
  invoiceId: string;
  studentId: number;
  studentName: string;
  parentId: number;
  parentName: string;
  discount: number;
  amount: number;
  description: string;
  dueDate: string;
  paidFor: string;
  sendToParent: boolean;
  sendToStudent: boolean;
  allowInstallment: boolean;
  // maxInstallment: number;
  isAlreadyPaid: boolean;
  paymentTypeId: number;
  paymentTypeName: string;
  status: string;
  recurringInterval: string;
  recurringIntervalCount: number;
  iterations: number;
  paymentDetails: paymentHistory;
  transactionCharges: number;
  isBackDate: boolean;
}

export interface InvoiceInfoRes {
  totalElements: number;
  invoiceInfoList: InvoiceInfo[];
}

export interface transaction {
  receiptId: string;
  iteration: number;
  paymentMode: string;
  paymentStatus: number;
  transactionDate: string;
  webhookStatus: string;
  amountReceived: number;
  sessionId: string;
  eventId: string;
  transactionCharges: number;
  canDownloadInvoice: boolean;
}

export interface paymentHistory {
  invoiceId: string;
  isInstallmentPayment: boolean;
  linkStatus: string;
  paymentLinkId: string;
  transactions: transaction[];
  status: string;
  canShowUpdatePaymentMethodButton: boolean;
  // transactionDate: string;
  amount: string;
}

export interface ScoreDetail {
  rawScore: number;
  score: number;
  tscId?: number;
}

export interface SectionScoreDetail {
  sectionId: number;
  moduleName?: string;
  scoreDetails: ScoreDetail[];
}

export interface ScoringPattern {
  testId: number;
  sectionScoreDetails: SectionScoreDetail[];
}

export interface TestTypeTest {
  is_conversion_available: boolean;
  testCode: string;
  testId: number;
  testName: string;
  testTypeName: string;
  totalQuestions: number;
  totalSavedQuestions: number;
  selected?: boolean;
  assignedDate?: string;
  pauseAllowed?: boolean;
}

export interface DuplicateTestRequest {
  sourceTestId: number;
  newTestName: string;
  newTestCode: string;
}

export const testCategories = {
  TestPrep: 'Test Prep',
  AcademicCoaching: 'Academic Coaching'
};

export const editorTypes = {
  MathJax: 'MathJax',
  TikZ: 'TikZ',
  Katex: 'Katex',
  URL: 'URL',
  Images: 'Images',
  Empty: 'Empty'
};



export interface PotEvent {
  id: string;
  title: string;
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  tutor: string;
  recurrenceId?: string;
  location?: string;
  isActive?: boolean;
  type?: number;
  subject?: number;
  timeZone?: number;
  // Set for a saved batch class, so it can be edited through the event API
  bseId?: number;
  // Students see only the title (e.g. a holiday)
  hideDetails?: boolean;
}

export type RepeatUnit = 'weeks' | 'months';

export interface BatchScheduleEvent {
  bseId: number;
  bschId: number;
  batchId: number;
  batchName: string;
  studentId: number;
  classDate: string; // MM-DD-YYYY
  originalDate: string | null;
  start_date: string;
  end_date: string;
  startTime: string; // h:mm A
  endTime: string;
  day: number;
  day_display_name: string;
  timeZone: number;
  zone_display_name: string;
  subject: number;
  subject_display_name: string;
  title: string | null;
  // 1 = show only the title (e.g. a holiday)
  hideDetails?: number;
  type: number;
  type_display_name: string;
  tutor: string;
  courses: string[];
  classUrl: string;
  classUrl1: string;
  isDisabled: number;
  isCustomized: number;
}

export interface BatchScheduleEventsRes {
  msg: string;
  data: BatchScheduleEvent[];
}

export interface AdminBatchScheduleEvent {
  bseId: number;
  bschId: number;
  title?: string;
  classDate: string; // MM-DD-YYYY
  originalDate: string | null;
  startTime: string; // h:mm A
  endTime: string;
  day: number;
  timeZone: number;
  subject: number;
  type: number;
  tutor: string;
  classUrl: string;
  isDisabled: number;
  isCustomized: number;
  // 1 = students see only the title (e.g. a holiday)
  hideDetails?: number;
}

// Batch schedule time zone ids 1-5, as offered in the class form
export const TIME_ZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Asia/Calcutta'
];

// Batch schedule subject ids, as offered in the class form
export const SUBJECT_NAMES: Record<number, string> = {
  1: 'Math',
  2: 'English',
  3: 'Math and English',
  4: 'Science'
};

// Class card colours per subject, shared by the admin and student
// calendars: accent edge + soft tint, with dark text (CLASS_CARD_TEXT)
export const SUBJECT_COLORS: Record<number, { accent: string; tint: string }> =
  {
    1: { accent: '#2563eb', tint: '#dbeafe' },
    2: { accent: '#059669', tint: '#d1fae5' },
    3: { accent: '#7c3aed', tint: '#ede9fe' },
    4: { accent: '#d97706', tint: '#fef3c7' }
  };

export const CLASS_CARD_TEXT = '#1f2937';

export function subjectColors(subject: number): {
  accent: string;
  tint: string;
} {
  return SUBJECT_COLORS[subject] ?? { accent: '#475569', tint: '#e2e8f0' };
}

// Classes students see as title only, e.g. holidays
export const HIDDEN_CLASS_COLORS = { accent: '#f43f5e', tint: '#ffe4e6' };

// A class card's colours: soft rose when hidden, else its subject's
export function classCardColors(
  subject: number,
  hideDetails?: boolean | number
): { accent: string; tint: string } {
  return hideDetails ? HIDDEN_CLASS_COLORS : subjectColors(subject);
}

// 1 = this class only, 2 = this class and all future occurrences
export type BatchScheduleEventEditType = 1 | 2;

export interface UpdateBatchScheduleEventReq {
  bseId: number;
  editType: BatchScheduleEventEditType;
  title: string;
  classDate: string; // MM-DD-YYYY
  startTime: string; // h:mm A, same as create_edit_batch
  endTime: string;
  learningType: number;
  subject: number;
  tutor: string;
  classLink: string;
  // 1 = students see only the title; this class only (editType 1)
  hideDetails?: number;
}

// 1 = this class only, 2 = this class and all future occurrences,
// 3 = every class in the series
export type BatchScheduleEventDeleteType = 1 | 2 | 3;

export interface DeleteBatchScheduleEventReq {
  bseId: number;
  deleteType: BatchScheduleEventDeleteType;
}

export interface AdminBatchScheduleEventsRes {
  msg: string;
  data: {
    batchId: number;
    batchName: string;
    startDate: string;
    endDate: string;
    isBatchActive: number;
    courses: any[];
    students: any[];
    schedules: any[];
    events: AdminBatchScheduleEvent[];
  };
}
